<template>
  <v-app :style="{ background: $vuetify.theme.themes['light'].background }">
    <!-- Must have the app property -->
    <v-app-bar
      v-if="$route.name === 'Tiendas' || $route.name === 'CuentaGlobal' || $route.name === 'MisPedidosGlobal' || esFranquiciaApp"
      fixed
      color="white"
      app
      height="56"
      class="global-top-app-bar"
    >
      <v-spacer />
      <v-img
        class="global-top-app-bar__logo"
        max-height="50"
        max-width="50"
        height="50"
        width="50"
        contain
        :src="clientLogo"
        alt="Click Away"
      />
      <v-spacer />
      <div v-if="$route.name === 'Tiendas' || $route.name === 'CuentaGlobal' || $route.name === 'MisPedidosGlobal'" class="global-top-app-bar__actions">
      <v-menu
        v-model="globalAccountMenu"
        offset-y
        left
        :close-on-content-click="true"
        min-width="220"
        max-width="320"
        content-class="global-account-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="global-account-menu-btn"
            aria-label="Menú de cuenta"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="grey darken-2">mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list dense nav class="py-1 global-account-menu__list" min-width="220">
          <v-subheader class="text-caption font-weight-medium">
            Tu cuenta
          </v-subheader>
          <v-list-item v-if="!isLoggedIn" :disabled="cuentaLoading" @click="onGlobalLoginGoogle">
            <v-list-item-icon class="my-0 mr-3">
              <v-icon size="22">mdi-google</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">Iniciar sesión con Google</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="cuentaLoading" class="my-0">
              <v-progress-circular indeterminate size="18" width="2" color="primary" />
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="isLoggedIn" @click="onGlobalMiCuenta">
            <v-list-item-icon class="my-0 mr-3">
              <v-icon size="22" color="primary">mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">Mi cuenta</v-list-item-title>
              <v-list-item-subtitle v-if="userEmail" class="text-wrap">{{ userEmail }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isLoggedIn" @click="onGlobalMisPedidos">
            <v-list-item-icon class="my-0 mr-3">
              <v-icon size="22" color="primary">mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">Mis pedidos</v-list-item-title>
              <v-list-item-subtitle class="text-wrap">De todas las tiendas</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isLoggedIn" :disabled="cuentaLoading" @click="onGlobalLogout">
            <v-list-item-icon class="my-0 mr-3">
              <v-icon size="22">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-alert
            v-if="authRedirectError"
            type="error"
            dense
            outlined
            class="ma-2 mb-0"
          >
            <span class="text-caption" style="white-space: pre-wrap;">{{ authRedirectError }}</span>
          </v-alert>
        </v-list>
      </v-menu>
      </div>
    </v-app-bar>
    <v-app-bar color="primary" fixed app height="56" class="store-top-app-bar" v-else>
      <div class="d-flex align-center flex-shrink-0 app-bar-brand" v-if="showSiteClientMenu">
        <v-btn
          icon
          dark
          class="ma-0 pa-0 brand-menu-btn"
          aria-label="Abrir menú"
          @click="siteMenuOpen = !siteMenuOpen"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-img class="brand-logo" max-height="50" max-width="50" height="50" width="50" contain :src="clientLogo" :alt="clientName" />
      </div>
      <template v-else>
        <v-img class="brand-logo" max-height="50" max-width="50" height="50" width="50" contain :src="clientLogo" :alt="clientName" />
      </template>
      <div
        v-if="$route.name !== 'Tiendas'"
        class="store-title-wrap"
        :title="clientName"
      >
        <h1 v-if="isStoreHome" class="store-title white--text">{{ clientName }}</h1>
        <span v-else class="store-title white--text">{{ clientName }}</span>
      </div>
      <v-spacer class="flex-grow-0 flex-shrink-0" style="width: 4px;"></v-spacer>
      <buscador v-if="!$isMobile() && $route.name !== 'CuentaGlobal' && $route.name !== 'MisPedidosGlobal'"></buscador>
      <v-btn
        v-if="!tiendaCerrada && getTotalItems > 0"
        color="white"
        text
        class="store-cart-btn flex-shrink-0"
        aria-label="Ver carrito"
        @click="onOpenCart"
      >
        <v-badge
          :content="getTotalItems > 9 ? '+9' : getTotalItems"
          color="secondary"
          overlap
        >
          <v-icon large>mdi-cart</v-icon>
        </v-badge>
      </v-btn>
    </v-app-bar>
    <site-client-menu v-if="showSiteClientMenu" v-model="siteMenuOpen" />
    <v-main :class="{ 'main-with-categories-bar': hasCategoriesBar }">
      <v-snackbar
        v-model="showWarning"
        color="warning"
        timeout="8000"
        top
        multi-line
        elevation="2"
        class="app-warning-snackbar"
      >
        <div class="text-body-2" style="white-space: pre-wrap;">{{ textWarning }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn
            text
            v-bind="attrs"
            @click="showWarning = false"
          >
            OK
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar
        v-model="showAuthError"
        color="error"
        timeout="-1"
        bottom
        multi-line
      >
        <div class="text-body-2">No se pudo iniciar sesión con Google</div>
        <div class="text-caption mt-1" style="white-space: pre-wrap;">{{ authRedirectError }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="showAuthError = false">
            OK
          </v-btn>
        </template>
      </v-snackbar>
      <cart-dialog :isOpen.sync="openCart" v-if="!$route.params.mesaId"></cart-dialog>
      <tienda-cerrada-card v-if="tiendaActual && !$route.params.mesaId"></tienda-cerrada-card>
      <QRCartDialog :isOpen.sync="openCart" v-if="showCart && $route.params.mesaId" @openCart="openCart = false"></QRCartDialog>
      <buscador v-if="$isMobile() && !$route.params.mesaId && $route.name !== 'CuentaGlobal' && $route.name !== 'MisPedidosGlobal'"></buscador>
      <router-view
        @showCart="showCart = $event"
        @showAlert="showWarning = true, textWarning = $event.message" />
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { bus } from '@/helpers/bus.js'
import { DEFAULT_THEME_COLORS, LAST_CLIENT_STORAGE_KEY } from '@/helpers/defaultTheme'
import CartDialog from './components/dialogs/CartDialog.vue'
import Buscador from './components/Buscador.vue'
import TiendaCerradaCard from './components/cards/TiendaCerradaCard.vue'
import QRCartDialog from './components/dialogs/QRCartDialog.vue'
import SiteClientMenu from './components/SiteClientMenu.vue'

export default {
  components: { CartDialog, Buscador, TiendaCerradaCard, QRCartDialog, SiteClientMenu },
  name: 'App',
  computed: {
    ...mapGetters('Categorias', ['categorias']),
    ...mapGetters('Carrito', ['getTotalItems']),
    ...mapGetters('App', ['data', 'tiendaCerrada']),
    ...mapGetters('Cuenta', ['isLoggedIn', 'userEmail']),
    ...mapState('App', ['appLogo', 'tiendaActual']),
    ...mapState('Cuenta', {
      cuentaLoading: (s) => s.loading,
      authRedirectError: (s) => s.authRedirectError
    }),
    clientName () {
      return this.tiendaActual ? this.tiendaActual : 'Clickaway'
    },
    isStoreHome () {
      return ['Home', 'HomeShort', 'ProductosMobile', 'MesaQRProductos'].includes(this.$route.name)
    },
    clientLogo () {
      return this.appLogo ? this.appLogo : 'https://info.clickaway.app/images/clickaway-logo.png' // 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/500px-Flag_of_Argentina.svg.png'
    },
    showSiteClientMenu () {
      const client = this.$route.params.client
      if (!client) return false
      const excluded = ['Tiendas', 'CuentaGlobal', 'Sucursales', 'PageNotFound', 'Info']
      return !excluded.includes(this.$route.name)
    },
    esFranquiciaApp () {
      return this.$route.name === 'Sucursales' && process.env.VUE_APP_LISTAR_FRANQUICIAS === 'TRUE'
    },
    hasCategoriesBar () {
      // La barra de categorías está visible en Home mobile cuando hay categorías
      return this.$isMobile() &&
             (this.$route.name === 'Home' || this.$route.name === 'HomeShort' || this.$route.name === 'ProductosMobile') &&
             !this.$route.params.mesaId &&
             this.categorias &&
             this.categorias.length > 0
    }
  },
  data () {
    return {
      isLoading: false,
      showCart: false,
      openCart: false,
      showWarning: false,
      textWarning: null,
      siteMenuOpen: false,
      globalAccountMenu: false,
      showAuthError: false
    }
  },
  watch: {
    authRedirectError (val) {
      this.showAuthError = !!val
    },
    '$route.fullPath' () {
      this.siteMenuOpen = false
      this.globalAccountMenu = false
      this.persistLastClientFromRoute(this.$route)
    },
    data (val) {
      if (!val) {
        this.resetThemeToAppDefaults()
        return
      }
      this.$vuetify.theme.themes.light.primary = val.PrimaryColor || DEFAULT_THEME_COLORS.primary
      this.$vuetify.theme.themes.light.secondary = val.SecondaryColor || DEFAULT_THEME_COLORS.secondary
    }
  },
  mounted () {
    this.showCart = false
    this.persistLastClientFromRoute(this.$route)
    if (!this.data) {
      this.resetThemeToAppDefaults()
    }
  },
  methods: {
    ...mapActions('Cuenta', ['loginGoogle', 'logout']),
    resetThemeToAppDefaults () {
      this.$vuetify.theme.themes.light.primary = DEFAULT_THEME_COLORS.primary
      this.$vuetify.theme.themes.light.secondary = DEFAULT_THEME_COLORS.secondary
    },
    persistLastClientFromRoute (route) {
      const client = route && route.params ? route.params.client : null
      if (!client || typeof client !== 'string') return
      const reserved = ['tiendas', 'sucursales', 'tienda', 'checkout']
      if (reserved.includes(client.toLowerCase())) return
      try {
        localStorage.setItem(LAST_CLIENT_STORAGE_KEY, client)
      } catch (e) {}
    },
    async onGlobalLoginGoogle () {
      this.globalAccountMenu = false
      await this.loginGoogle()
    },
    onGlobalMiCuenta () {
      this.globalAccountMenu = false
      if (this.$route.name === 'Sucursales' && this.$route.params.id) {
        this.$router.push({
          name: 'CuentaGlobal',
          query: { from: 'sucursales', franquicia: String(this.$route.params.id) }
        }).catch(() => {})
        return
      }
      this.$router.push({ name: 'CuentaGlobal', query: { from: 'tiendas' } }).catch(() => {})
    },
    onGlobalMisPedidos () {
      this.globalAccountMenu = false
      this.$router.push({ name: 'MisPedidosGlobal' }).catch(() => {})
    },
    async onGlobalLogout () {
      this.globalAccountMenu = false
      await this.logout()
    },
    onOpenCart () {
      this.openCart = true
      bus.$emit('ver-carrito')
    }
  }
}
</script>
<style scoped>
.main-with-categories-bar {
  padding-top: 120px !important; /* Espacio para navbar (56px) + barra de categorías fija (~44px con padding y altura de chips) */
}

.app-bar-brand {
  gap: 2px;
  margin-right: 4px;
}

.brand-menu-btn {
  min-width: 40px !important;
  width: 40px;
}

.brand-logo {
  flex-shrink: 0;
  height: 50px !important;
  width: 50px !important;
  max-height: 50px !important;
  max-width: 50px !important;
}

.global-account-menu-btn {
  margin-right: 0;
}

/* Logo centrado en la barra; menú a la derecha */
.global-top-app-bar,
.store-top-app-bar {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 56px !important;
  max-height: 56px !important;
  overflow: hidden;
  z-index: 5;
}

.global-top-app-bar >>> .v-toolbar__content,
.store-top-app-bar >>> .v-toolbar__content {
  height: 56px !important;
  max-height: 56px !important;
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  overflow: hidden;
  padding-left: 8px !important;
  padding-right: 4px !important;
}

.store-title-wrap {
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 10px;
  margin-right: 4px;
  overflow: hidden;
}

.store-title {
  display: block;
  max-width: 100%;
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.store-cart-btn {
  min-width: 48px !important;
  margin-right: 2px !important;
}

.global-top-app-bar__logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 0;
  height: 50px !important;
  width: 50px !important;
  max-height: 50px !important;
  max-width: 50px !important;
}

.global-top-app-bar__actions {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

/* Evita que el menú de cuenta ensanche el header */
.global-account-menu {
  max-width: 320px;
}

.global-account-menu__list {
  max-width: 320px;
}

.global-account-menu .v-list-item__title,
.global-account-menu .v-list-item__subtitle {
  white-space: normal;
}

.app-warning-snackbar {
  max-width: 520px !important;
}
</style>
